import { Component, Input, inject } from '@angular/core';
import { FormArray, FormBuilder, FormControl, Validators } from '@angular/forms';
import { CustomEmailValidator } from '@app/core/services/media.service';

@Component({
  selector: 'flow-email-sendouts-list',
  templateUrl: './email-sendouts-list.component.html',
  styleUrls: ['./email-sendouts-list.component.scss'],
})
export class EmailSendoutsListComponent {
  private fb = inject(FormBuilder);

  @Input() emailRecipients: FormArray<FormControl<string | null>>;
  @Input() isEditMode: boolean = true;

  get isAddDisabled(): boolean {
    if (!this.isEditMode) {
      return true;
    }
    const length = this.emailRecipients.length;
    if (length === 0) {
      return false;
    }
    if (length === 1) {
      return false;
    }
    const lastControl = this.emailRecipients.at(length - 1);
    return lastControl.invalid;
  }

  addEmailRecipient(): void {
    this.emailRecipients.push(this.createEmailControl());
  }

  removeEmailRecipient(index: number): void {
    if (this.emailRecipients.length > 1) {
      this.emailRecipients.removeAt(index);
    }
  }

  private createEmailControl(): FormControl<string | null> {
    return this.fb.control<string | null>('', [Validators.required, CustomEmailValidator()]);
  }
}
